import { RecordMask } from '@skinsoft/types'

/* tslint:disable:object-literal-sort-keys */

// tslint:disable-next-line:variable-name
export const identifierAndContextRecordMasks: RecordMask = {
    name: {
        translatedString: {
            fr: 'Masque Reporter',
        },
        translatedId: null,
    },
    categories: [
        {
            label: {
                translatedString: {
                    fr: 'IDENTIFIANTS DU CONSTAT',
                    'fr-ca': 'IDENTIFIANTS DU CONSTAT',
                    en: 'GENERAL INFORMATION',
                    'en-us': 'GENERAL INFORMATION',
                    nl: 'ALGEMENE INFORMATIE',
                    es: 'IDENTIFICADORES DEL INFORME',
                    it: 'IDENTIFICATORI DI OSSERVAZIONE',
                    no: 'Rapportens identifikatorer',
                    de: 'ZUSTANDSPROTOKOLL-ID',
                    se: 'MISSING TRANSLATION',
                },
                translatedId: null,
            },
            maskFields: [
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "5a3925ec08813b0001387c63",
                        className: "org.skinsoft.backend.types.entityfield.EntityField",
                        entity: "conditionReport",
                        schema: "conditionReportCS",
                        name: "referenceNumber",
                        mandatorySystem: false,
                        type: {
                            className: "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            type: "String"
                        },
                        entityFields: [],
                        isChildren: false,
                        isInList: false,
                        path: "conditionReportCS.referenceNumber",
                        pathType: "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.lang.String",
                        isReadOnly: false,
                        isComputed: false,
                        weight: 1.0,
                        needId: false,
                        usableForFacets: true,
                        isFieldConditionNumbering: false,
                        lastModificationTimestamp: "1722523142280",
                        backwardSearchEnable: false,
                        fieldExcludeCheckInstitution: false
                    },
                    children: null,
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "5a3925ec08813b0001387c67",
                        className: "org.skinsoft.backend.types.entityfield.EntityField",
                        entity: "conditionReport",
                        "schema": "conditionReportCS",
                        "name": "reportType",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                            "type": "ThesaurusTerm",
                            "thesaurusIdentifier": "conditionReport"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditionReportCS.reportType",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142290",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: null,
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "5a3925ec08813b0001387c66",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditionReportCS",
                        "name": "reportReason",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                            "type": "ThesaurusTerm",
                            "thesaurusIdentifier": "conditionReportMotif"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditionReportCS.reportReason",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142289",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: null,
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },

                /*{
                    entityField: {
                        entityFieldId: '5d4c49010de7d241b997e27d',
                        entity: 'recolement',
                        abstractEntity: null,
                        schema: 'recolementIdentificationSchema',
                        name: 'numberIdentifier',
                        mandatorySystem: false,
                        type: {
                            type: 'String',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [],
                        path: 'recolementIdentificationSchema.numberIdentifier',
                        pathOffline: 'recolementIdentificationSchema.numberIdentifier.value',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: true,
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    children: null,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: null,
                    columnDisplay: true,
                    paginated: null,
                },*/
            ],
        },
        {
            label: {
                translatedString: {
                    fr: "CONTEXTE DU CONSTAT D'ÉTAT",
                    'fr-ca': "CONTEXTE DU CONSTAT D'ÉTAT",
                    en: 'CONTEXT',
                    'en-us': 'CONTEXT',
                    nl: 'CONTEXT',
                    es: 'CONTEXTO DEL INFORME DE ESTADO',
                    it: 'CONTESTO DEL RAPPORTO SULLE CONDIZIONI',
                    no: 'RAPPORTENS KONTEKST',
                    de: 'KONTEXT DER ZUSTANDSBEGUTACHTUNG',
                    se: 'MISSING TRANSLATION',
                },
                translatedId: null,
            },
            maskFields: [
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "5a3925ec08813b0001387c64",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditionReportCS",
                        "name": "reportDate",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "SkinDate"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditionReportCS.reportDate",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|org.skinsoft.backend.types.date.SkinDate",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142283",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: null,
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "5a3925ec08813b0001387c6a",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditionReportCS",
                        "name": "location",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "TranslatedString"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditionReportCS.location",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|org.skinsoft.backend.types.translatedstring.TranslatedString",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142301",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: null,
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "5a3925ec08813b0001387c65",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditionReportCS",
                        "name": "reportEditor",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "ReportEditor"
                            },
                            "listClass": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.complex.ReportEditor"
                        },
                        "entityFields": [
                            {
                                entityFieldId: "5d4c49000de7d241b997e144",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "reportName",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ReferenceEntityFieldType",
                                    "type": "Alias",
                                    "subTypes": [],
                                    "filter": "591ca6a8857aca1231abcd4e",
                                    "isRestrictive": false,
                                    "esPath": "aliasSchema.tags.ref",
                                    "trueType": "Alias",
                                    "useTrueType": false
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.reportEditor.reportName",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.alias.Alias",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142285",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                        ],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditionReportCS.reportEditor",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142288",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: [
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "5d4c49000de7d241b997e144",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "reportName",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ReferenceEntityFieldType",
                                    "type": "Alias",
                                    "subTypes": [],
                                    "filter": "591ca6a8857aca1231abcd4e",
                                    "isRestrictive": false,
                                    "esPath": "aliasSchema.tags.ref",
                                    "trueType": "Alias",
                                    "useTrueType": false
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.reportEditor.reportName",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.alias.Alias",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142285",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        }
                    ],
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },

                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "5a3925ec08813b0001387c69",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditionReportCS",
                        "name": "signers",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "Signer"
                            },
                            "listClass": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.complex.Signer"
                        },
                        "entityFields": [
                            {
                                entityFieldId: "5aab921d2ab79c000137ee1c",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "signer",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.signers.signer",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142292",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "65b9137e9b743e28af07c63d",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "positionOfSignatory",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "function"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.signers.positionOfSignatory",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142295",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                        ],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditionReportCS.signers",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142300",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: [
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "5aab921d2ab79c000137ee1c",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "signer",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.signers.signer",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142292",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "65b9137e9b743e28af07c63d",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "positionOfSignatory",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "function"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.signers.positionOfSignatory",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142295",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                    ],
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },
            ],
        },
        {
            label: {
                translatedString: {
                    fr: "CONDITIONNEMENT",
                    'fr-ca': "CONDITIONNEMENT",
                    en: 'CONDITIONING',
                    'en-us': 'CONDITIONING',
                    nl: 'VERPAKKING',
                    es: 'EMBALAJE',
                    it: 'IMBALLAGGIO',
                    no: 'EMBALLASJE',
                    de: 'VERPACKUNG',
                    se: 'FÖRPACKNING',                      
                },
            },
            maskFields: [         
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "651435616baf4b750964dedb",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditioningSchema",
                        "name": "typeOfPackaging",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "TypeOfPackaging",
                        },
                        "entityFields": [
                            {
                                entityFieldId: "651faca2a172f477f53b0068",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditioningSchema",
                                "name": "type",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "conditioningSchema.typeOfPackaging.type",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.ConditioningSchema|org.skinsoft.backend.schemas.conditionreport.TypeOfPackaging|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142406",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "651faca2a172f477f53b0069",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditioningSchema",
                                "name": "materials",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                                    "type": "List",
                                    "entityFieldType": {
                                        "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                        "type": "TranslatedString"
                                    }
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "conditioningSchema.typeOfPackaging.materials",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.ConditioningSchema|org.skinsoft.backend.schemas.conditionreport.TypeOfPackaging|java.util.List",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142408",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "651faca2a172f477f53b006a",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditioningSchema",
                                "name": "furtherInformations",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                                    "type": "List",
                                    "entityFieldType": {
                                        "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                        "type": "TranslatedString"
                                    }
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "conditioningSchema.typeOfPackaging.furtherInformations",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.ConditioningSchema|org.skinsoft.backend.schemas.conditionreport.TypeOfPackaging|java.util.List",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142409",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                        ],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditioningSchema.typeOfPackaging",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.ConditioningSchema|org.skinsoft.backend.schemas.conditionreport.TypeOfPackaging",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142410",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: [
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "651faca2a172f477f53b0068",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditioningSchema",
                                "name": "type",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "conditioningSchema.typeOfPackaging.type",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.ConditioningSchema|org.skinsoft.backend.schemas.conditionreport.TypeOfPackaging|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142406",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined                            
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "651faca2a172f477f53b0069",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditioningSchema",
                                "name": "materials",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                                    "type": "List",
                                    "entityFieldType": {
                                        "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                        "type": "TranslatedString"
                                    }
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "conditioningSchema.typeOfPackaging.materials",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.ConditioningSchema|org.skinsoft.backend.schemas.conditionreport.TypeOfPackaging|java.util.List",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142408",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined                            
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "651faca2a172f477f53b006a",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditioningSchema",
                                "name": "furtherInformations",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                                    "type": "List",
                                    "entityFieldType": {
                                        "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                        "type": "TranslatedString"
                                    }
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "conditioningSchema.typeOfPackaging.furtherInformations",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.ConditioningSchema|org.skinsoft.backend.schemas.conditionreport.TypeOfPackaging|java.util.List",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142409",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined                            
                        },
                    ],
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },
                
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "651435616baf4b750964dee0",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditioningSchema",
                        "name": "transportAccessories",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "TranslatedString"
                            }
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditioningSchema.transportAccessories",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.ConditioningSchema|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142415",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: null,
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined                            
                },
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "651435616baf4b750964dedf",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditioningSchema",
                        "name": "crateNumber",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "TranslatedString"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditioningSchema.crateNumber",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.ConditioningSchema|org.skinsoft.backend.types.translatedstring.TranslatedString",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142412",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: null,
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined                            
                },
            ]
        },
    ],
    level: 'adminLevel',
    userId: '595ca6a7857aba0001a00001',
    entityTargetId: '736bb6b8857abf0001ac9888',
    entityTarget: 'recolement',
    isInputMask: true,
    categoriesDisplay: true,
    workspaceCreation: '5d6917c3fb6ee95ed082f268',
    workspaceSharing: [],
    isPatternMask: false,
    pattern: null,
    _links: {
        self: {
            href: 'http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650',
        },
        'record-masks': {
            href: 'http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650',
        },
        'mask-fields': {
            href: 'http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650/mask-fields',
        },
    },
    id: '6070579b0a6d211f1520a650',
}
